import { render } from "./ValuationRequests.vue?vue&type=template&id=c1a946ec&scoped=true"
import script from "./ValuationRequests.vue?vue&type=script&lang=js"
export * from "./ValuationRequests.vue?vue&type=script&lang=js"

import "./ValuationRequests.vue?vue&type=style&index=0&id=c1a946ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a946ec"]])

export default __exports__